import React from 'react';
import PropTypes from 'prop-types';
import { useFind } from 'src/api/APIHooks';
import AddCaseDetailsForm from '../../components/Cases/components/AddCaseDetailsForm';

function AddCaseDetailsFormContainer(props) {
  const { contactId } = props;

  const {
    data: clientNeedsData,
    isLoading: isClientNeedsLoading,
    error: clientNeedsError,
  } = useFind(
    `people/${contactId}/person_conditions`,
    { most_recent: true },
    {
      queryConfig: {
        placeholderData: undefined,
      },
    },
  );
  return (
    <AddCaseDetailsForm
      {...props}
      clientNeedsFromQuery={clientNeedsData?.data?.data || []}
      isClientNeedsLoading={isClientNeedsLoading}
      clientNeedsError={clientNeedsError}
    />
  );
}

AddCaseDetailsFormContainer.propTypes = {
  contactId: PropTypes.string.isRequired,
};

export default AddCaseDetailsFormContainer;
